import { Observable } from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";

export class EditPlanCommand<
  T extends object & { disabled: boolean },
  S extends IApiService<T> & {
    editPlan: (el: T) => Observable<any>;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  layout: "flat" | "raised" | "normal" = "raised";
  icon = "edit_outline";
  constructor(public service: S) {}
  execute(el: T) {
    this.service.editPlan(el).subscribe((res) => {
      if (res) {
        this.receiver.onSuccess();
      }
    });
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return el.disabled || this.receiver.isLoading;
  }
}
